import { useEffect, useState } from "react";
import { ActionType, ChatMessageButtonOptionsInterface } from "../interfaces";
import { hexToRgb } from "../util";

import DOMPurify from "dompurify";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { chatActions } from "../store/chat/slice";

// const actionStep = ({ type, link }: ActionType) => {
//   switch (type) {
//     case "redirect":
//       window.open(link, "_blank");
//       break;
//     default:
//       console.log("This action time is not supported.");
//       return;
//   }
// };

const ChatMessageButtonOptions: React.FC<ChatMessageButtonOptionsInterface> = ({
    triggerNextStep,
    values = {},
    step,
    options,
    theme,
    setDataValues,
}) => {
    const dispatch = useAppDispatch();
    const chatHasBeenEnded = useAppSelector((state) => state.chat.chatHasBeenEnded);
    const chatHasBeenEscalated = useAppSelector((state) => state.chat.chatHasBeenEscalated);
    const isLivechatEnabled = useAppSelector((state) => state.chat.isLivechatEnabled);
    const [formattedOptions, setFormattedOptions] = useState<any[]>([]);

    const handleAction = (actionType: ActionType) => {
        switch (actionType?.type) {
            case "redirect":
                window.open(actionType?.link, "_blank");
                break;
            case "resumeBotConversation":
                setDataValues({
                    chat_to_expert: false,
                });
                dispatch(chatActions.setChatHasBeenEscalated(false));
                dispatch(chatActions.resumeBotConversation());
                break;
            default:
                break;
        }
    };

    const excludedSteps = new Set([
        "contact_requested",
        "applicant1_firstName",
        "applicant1_lastName",
        "applicant1_email",
        "applicant1_contactNumber",
        "appointment_date",
        "select_date",
        "appointment_api",
        "loading_insurance",
        "loading_illustration",
        "illustration_page",
    ]);

    const apiKeyWithBookAppointmentButton =
        theme?.apiKey === "abde4f0e-b4de-4166-8c87-a0bdf1500bb6" ||
        theme?.apiKey === "0155d30f-961b-42b8-9b07-7386aeb48913";

    const shouldProcessStep =
        !formattedOptions.some((obj: any) => obj.trigger === "appointment_api") &&
        !excludedSteps.has(step.id!) &&
        apiKeyWithBookAppointmentButton;

    useEffect(() => {
        const initializeOptions = async () => {
            let optionsList = typeof options === "function" ? await options(values) : options!;
            if (optionsList) {
                const items = optionsList
                    .map((option) => ({
                        label: option.label!,
                        value: option.value!,
                        trigger: option.trigger!,
                        enable: option.enable!,
                        action: option?.action,
                    }))
                    .filter((o) => (o?.enable ? o.enable(values) : true));
                if (!chatHasBeenEnded && !chatHasBeenEscalated && isLivechatEnabled) {
                    items.push({
                        label: "Let's Chat Now",
                        value: "Let's Chat Now",
                        trigger: () => {
                            dispatch(chatActions.setChatHasBeenEscalated(true));

                            return "no-worries";
                        },
                        enable: () => true,
                        action: {},
                    });
                }
                setFormattedOptions(items);
                dispatch(
                    chatActions.sendToCMS({
                        message: {
                            ...step,
                            escalated: step?.escalated || chatHasBeenEscalated,
                            user: {
                                firstName: values?.applicant1_firstName,
                                lastName: values?.applicant1_lastName,
                                email: values?.applicant1_email,
                            },
                            options: items.map((options) => ({
                                label: options.label,
                                value: options.value,
                            })),
                        },
                    })
                );
            }
        };

        initializeOptions();
        /*eslint-disable react-hooks/exhaustive-deps*/
    }, []);

    return (
        <div className="conversation-message-button">
            {formattedOptions.map(({ label, value, trigger, action }, index) => (
                <div
                    id={`${step?.id}_btn-${index + 1}`}
                    key={`${value}-${index}`}
                    className="conversation-message-option"
                    data-press={value}
                    style={{
                        backgroundColor: theme?.customization?.primaryColor,
                        borderColor: theme?.customization?.primaryColor,
                        boxShadow: `0px 12px 18px -6px rgb(${
                            hexToRgb(theme?.customization?.primaryColor!)?.r
                        } ${hexToRgb(theme?.customization?.primaryColor!)?.g} ${
                            hexToRgb(theme?.customization?.primaryColor!)?.b
                        } / 53%)`,
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#FFF";
                        e.currentTarget.style.borderColor = theme?.customization?.primaryColor!;
                        e.currentTarget.style.color = theme?.customization?.primaryColor!;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = theme?.customization?.primaryColor!;
                        e.currentTarget.style.borderColor = theme?.customization?.primaryColor!;
                        e.currentTarget.style.color = "#FFF";
                    }}
                    onClick={async () => {
                        if (
                            value === "Book an Appointment" &&
                            step.id === "talk_with_advisor" &&
                            (theme?.apiKey === "bb3d6794-a893-49c1-b8ed-537b65c75853" ||
                                theme?.apiKey === "0155d30f-961b-42b8-9b07-7386aeb48913" ||
                                theme?.apiKey === "abde4f0e-b4de-4166-8c87-a0bdf1500bb6")
                        ) {
                            window.open(theme?.links?.calendarURL);
                            triggerNextStep({
                                currentStep: step!,
                                value,
                                trigger,
                            });

                            await new Promise((resolve) => setTimeout(resolve, 2000));

                            action && handleAction(action);
                        } else if (
                            value === "Book an Appointment" &&
                            (theme?.apiKey === "bb3d6794-a893-49c1-b8ed-537b65c75853" ||
                                theme?.apiKey === "0155d30f-961b-42b8-9b07-7386aeb48913" ||
                                theme?.apiKey === "abde4f0e-b4de-4166-8c87-a0bdf1500bb6")
                        ) {
                            window.open(theme?.links?.calendarURL);
                        } else {
                            triggerNextStep({
                                currentStep: step!,
                                value,
                                trigger,
                            });

                            await new Promise((resolve) => setTimeout(resolve, 2000));

                            action && handleAction(action);
                        }
                    }}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(label) }}
                />
            ))}
            {shouldProcessStep ? (
                <>
                    <div
                        id={`${step?.id}_btn-${formattedOptions.length + 2}`}
                        key={`Book an Appointment`}
                        className="conversation-message-option"
                        data-press={`Book an Appointment`}
                        style={{
                            backgroundColor: theme?.customization?.primaryColor,
                            borderColor: theme?.customization?.primaryColor,
                            boxShadow: `0px 12px 18px -6px rgb(${
                                hexToRgb(theme?.customization?.primaryColor!)?.r
                            } ${hexToRgb(theme?.customization?.primaryColor!)?.g} ${
                                hexToRgb(theme?.customization?.primaryColor!)?.b
                            } / 53%)`,
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#FFF";
                            e.currentTarget.style.borderColor = theme?.customization?.primaryColor!;
                            e.currentTarget.style.color = theme?.customization?.primaryColor!;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                                theme?.customization?.primaryColor!;
                            e.currentTarget.style.borderColor = theme?.customization?.primaryColor!;
                            e.currentTarget.style.color = "#FFF";
                        }}
                        onClick={async () => {
                            if (
                                step.id === "talk_with_advisor" &&
                                (theme?.apiKey === "bb3d6794-a893-49c1-b8ed-537b65c75853" ||
                                    theme?.apiKey === "0155d30f-961b-42b8-9b07-7386aeb48913" ||
                                    theme?.apiKey === "abde4f0e-b4de-4166-8c87-a0bdf1500bb6")
                            ) {
                                window.open(theme?.links?.calendarURL);
                                triggerNextStep({
                                    currentStep: step!,
                                    value: "Book an Appointment",
                                    trigger: "applicant1_firstName",
                                });

                                await new Promise((resolve) => setTimeout(resolve, 2000));
                            } else if (
                                theme?.apiKey === "bb3d6794-a893-49c1-b8ed-537b65c75853" ||
                                theme?.apiKey === "0155d30f-961b-42b8-9b07-7386aeb48913" ||
                                theme?.apiKey === "abde4f0e-b4de-4166-8c87-a0bdf1500bb6"
                            ) {
                                window.open(theme?.links?.calendarURL);
                            } else {
                                triggerNextStep({
                                    currentStep: step!,
                                    value: "Book an Appointment",
                                    trigger: "applicant1_firstName",
                                });

                                await new Promise((resolve) => setTimeout(resolve, 2000));
                            }
                        }}
                    >
                        Book an Appointment
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default ChatMessageButtonOptions;
